const colors = {
    green: { base: '#51dd85', hover: '#46c575' },
    blue: { base: '#60a5fa', hover: '#0073ff' },
    red: { base: '#f87171', hover: '#ff0000' },
    yellow: { base: '#facc15', hover: '#ffb700' },
};

export { colors };
